module.exports = __webpack_public_path__ + "img/firts-portfolio_box.fc1d854c.png";